import * as React from 'react'
import { IntlProvider } from 'react-intl'
import {
  Action,
  any,
  async,
  AsyncState,
  fromJSX,
  loadingAsyncState,
  nothing,
  stateful,
  Unit,
  unloadedAsyncState
} from 'widgets-for-react'
import { setFlashMessage } from '../../../api/flash'
import {
  getIdealIssuers,
  getPaymentMethods,
  getPaymentStatus,
  IdealIssuerResponse,
  PaymentStatusResponse,
  startPayment
} from '../../../api/payments'
import { StartPaymentResponse } from '../../../api/payments'
import { PaymentMethod } from '../../../types/types'
import {
  idealIssuersLoader,
  paymentMethodsLoader,
  PaymentMethodsSkeletonScreen,
  Show,
  startPaymentLoader
} from '../../../widgets/payments'

type Props = {
  booking_id: string
  payment_id: string
}

export type State = {
  checkedPaymentMethod: string
  checkedIdealIssuer: string
  paymentMethods: AsyncState<PaymentMethod[]>
  idealIssuers: AsyncState<IdealIssuerResponse>
  startPayment: AsyncState<StartPaymentResponse>
  paymentStatus: AsyncState<PaymentStatusResponse>
  setOngoingFlash: AsyncState<Unit>
}

const initialState = (props: Props): State => ({
  checkedPaymentMethod: null,
  checkedIdealIssuer: null,
  startPayment: unloadedAsyncState(),
  paymentMethods: loadingAsyncState(_ => getPaymentMethods(props.booking_id)),
  idealIssuers: unloadedAsyncState(),
  paymentStatus: loadingAsyncState(_ => getPaymentStatus(props.payment_id)),
  setOngoingFlash: unloadedAsyncState()
})

class StatefulShowContainer extends React.Component<Props> {
  render() {
    return stateful<State>({ key: 'start-payment' })(s0 =>
      any<Action<State>>()([
        paymentMethodsLoader(s0.paymentMethods),
        idealIssuersLoader(s0.idealIssuers),
        startPaymentLoader(s0.startPayment),
        async<PaymentStatusResponse>()(s0.paymentStatus).map(u => s => ({
          ...s,
          paymentStatus: u(s.paymentStatus)
        })),
        async<Unit>()(s0.setOngoingFlash).map(u => s => ({
          ...s,
          setOngoingFlash: u(s.setOngoingFlash)
        })),
        fromJSX(setState =>
          s0.paymentStatus.kind === 'loaded' &&
          s0.paymentMethods.kind === 'loaded' &&
          !s0.paymentStatus.value.status.is_ongoing_status &&
          (s0.idealIssuers.kind === 'unloaded' ||
            s0.idealIssuers.kind === 'loaded') ? (
            <Show
              state={s0}
              setState={setState}
              paymentMethods={s0.paymentMethods.value}
              onSubmit={() =>
                setState(s => ({
                  ...s,
                  startPayment: loadingAsyncState(_ =>
                    startPayment({
                      payment_id: this.props.payment_id,
                      payment_method: s.checkedPaymentMethod,
                      ideal_issuer: s.checkedIdealIssuer
                    })
                  )
                }))
              }
            />
          ) : (
            <PaymentMethodsSkeletonScreen />
          )
        )
      ]).map(a => {
        const newState = a(s0)

        if (
          s0.setOngoingFlash.kind !== 'loaded' &&
          newState.setOngoingFlash.kind === 'loaded' &&
          newState.paymentStatus.kind === 'loaded'
        ) {
          window.location.href = newState.paymentStatus.value.booking_url
        }
        return {
          ...newState,
          paymentStatus:
            s0.startPayment.kind !== 'failed' &&
            newState.startPayment.kind === 'failed' &&
            newState.paymentStatus.kind !== 'loading'
              ? loadingAsyncState(_ => getPaymentStatus(this.props.payment_id))
              : newState.paymentStatus,
          idealIssuers:
            newState.paymentMethods.kind === 'loaded' &&
            s0.paymentMethods.kind !== 'loaded' &&
            newState.idealIssuers.kind === 'unloaded' &&
            newState.paymentMethods.value.map(p => p.name).includes('ideal')
              ? loadingAsyncState(_ => getIdealIssuers())
              : newState.idealIssuers,
          setOngoingFlash:
            s0.paymentStatus.kind !== 'loaded' &&
            newState.paymentStatus.kind === 'loaded' &&
            (newState.paymentStatus.value.status.is_ongoing_status ||
              newState.paymentStatus.value.status.marked_as_paid ||
              newState.paymentStatus.value.status.is_paid_status) &&
            newState.setOngoingFlash.kind === 'unloaded'
              ? loadingAsyncState(_ =>
                  setFlashMessage(
                    'alert',
                    newState.paymentStatus.kind !== 'loaded' ||
                      newState.paymentStatus.value.status.is_ongoing_status
                      ? 'payments.flash.opp.transaction_ongoing'
                      : 'payments.flash.opp.already_paid'
                  )
                )
              : newState.setOngoingFlash
        }
      })
    )(initialState(this.props)).run(_ => null)
  }
}

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <StatefulShowContainer {...props} />
  </IntlProvider>
)
